import { Fragment } from "react";
import { Card, Col } from "reactstrap";
import { P } from "../../../../AbstractElements";
import SvgIcon from "../../../CommonComponents/SvgIcon/SvgIcon";

const RibbonsCard = () => {
  return (
    <Fragment>
      <Col xl="4" md="6">
        <Card className="vertical-left-animate">
          <div className="ribbon-wrapper border border-1 height-equal alert-light-light">
            <div className="ribbon ribbon-success ribbon-bookmark">
              <span>Latest</span>
              <i className="fa fa-bolt" />
            </div>
            <P>Ribbon designs use the class of <em className="txt-danger">ribbon-bookmark &amp; vertical-left-animate</em> through create top-start ribbon and common class use "ribbon".</P>
          </div>
        </Card>
      </Col>
        <Col xl="4" md="6">
          <Card className="triangular-ribbon">
            <div className="ribbon-wrapper border border-1 height-equal">
              <div className="ribbon triangular-ribbon-box">
                <div><SvgIcon iconId="pricing"/></div>
              </div>
              <P>Ribbon designs use the class of <em className="txt-danger">triangular-ribbon-box</em> through create top-start ribbon and common class use "ribbon".</P>
            </div>
          </Card>
        </Col>
        <Col xl="4" md="6">
          <Card className="vertical-ribbon-animate">
            <div className="ribbon-vertical-right-wrapper border border-1 vertical-rp-space height-equal alert-light-light">
              <div className="ribbon ribbon-bookmark ribbon-vertical-right ribbon-warning">
                <div><i className="fa fa-bolt" /><span>FlashSale</span></div>
              </div>
              <P>Ribbon designs use the class of <em className="txt-danger">ribbon-vertical-right &amp; ribbon-bookmark</em> through create top-end ribbon and common class use "ribbon".</P>
            </div>
          </Card>
        </Col>
    </Fragment>
  );
};

export default RibbonsCard;
